var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProgramPage',{attrs:{"back-to":"/my-account","back-label":_vm.$t('My account').toString(),"title":_vm.$t('Reports').toString(),"empty":_vm.emptyText}},[(_vm.reports.length)?_c('ProgramReports',{attrs:{"reports":_vm.reports}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }